import React from "react";
import { Box } from "@rebass/grid";
import { messageWithLinks } from "../../shared/utils/text";
import { Update } from "./style";

const IncidentUpdatesList = (props) => {
  const { incidentUpdates } = props;
  return (
    <div className="updatesWrapper">
      {incidentUpdates.map((item) => (
        <Update key={item.id} className="incident-updates">
          <Box className="update-label" width={1 / 6}>
            <div className="time">{props.getDisplayTime(item.created_at)}</div>
          </Box>
          <Box className="update-message" width={4 / 6}>
            {item.message}
          </Box>
        </Update>
      ))}
    </div>
  );
};

export default IncidentUpdatesList;

export const RecentIncidentUpdate = ({ incidentUpdates }) => {
  const lastItem = incidentUpdates[incidentUpdates.length - 1];
  return (
    <div className="recents">
      <Box mb={3}>
        <span className="title"> Recent Update:</span>
        {lastItem.interim_status_mini ? (
          <span className="status">{` [ ${lastItem.interim_status_mini.value} ]`}</span>
        ) : null}
        <span className="message">  {messageWithLinks(lastItem.message)}</span>
      </Box>
    </div>
  );
};
